export enum SistemaEnum {
  App = 1,
  Bilhetagem = 2,
  CaixaTem = 3,
  Loja = 4,
  Tiqueteira = 5,
  PrestacaoContas = 6,
  Administrativo = 7,
}
